module.exports = __webpack_public_path__ + "img/newsIMG.4c14ff64.png";